import axios from "axios";
import { config } from "../../Network_Calls/config";

const getOrganizationUser = async () => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_SERVER_URL + "/customer/imp",
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

const getImplCustomers = async (impl) => {
  const response = await axios.post(
    process.env.REACT_APP_SERVER_URL + "/customer/all",
    {
      impl_name: impl,
    },
    {
      ...config(),
    }
  );
  return response;
};

const getCustomer = async (impl_id, id) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "/customer/info/" + id,
      {
        implementation_id: impl_id,
      },
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const postTag = async (impl_id, tag) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "/customer/tags/",
      {
        impl_id,
        tag,
      },
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
    return error.message;
  }
};


const getImplTags = async (impl_id) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "/customer/alltags/",
      {
        impl_id,
      },
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
    return error.message;
  }
};

const postTagData = async (tagData, tag_id) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "/customer/tag/data/",
      {
        tagData,
        tag_id,
      },
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};
const getTagData = async (tag_id) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "/customer/tagData/edit/",
      {
        tag_id,
      },
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

const deleteTag = async (tag_id) => {
  try {
    const response = await axios.delete(
      process.env.REACT_APP_SERVER_URL + `/customer/tagData/${tag_id}`,
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

const editTagData=async (cusId,tag_id) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + `/customer/tagData/editData/`,
      {
        cusId,
        tag_id
      },
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

const getViewsCount = async (domain_name) => {
  try {
    console.log("impleeee", domain_name);
    //const impl_id = implementations.map(impl =>parseInt( impl._id));
    
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + `/customer/all-recent-cutomers`,
      {
        domain_name:domain_name
      },
      {
        ...config(),
      }
    );
    console.log("response", response);
    return response;
  } catch (error) {
    console.log(error);
  }
};


export {
  getViewsCount,
  getOrganizationUser,
  getImplCustomers,
  getCustomer,
  postTag,
  getImplTags,
  postTagData,
  getTagData,
  deleteTag,
  editTagData
};
